import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-toil-occurrence-report',
    templateUrl: './toil-occurrence-report.component.html',
    styleUrls: ['./toil-occurrence-report.component.scss']
})
export class ToilOccurrenceReportComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
